import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { CarusaleView } from "../../../components/Carusel/Carusel";
import { MediaCarusel } from "../../../components/MediaCarusel/index";
// Spinner Loader
import { library } from "@fortawesome/fontawesome-svg-core";
import imgBlog from "media/home/blog_icon.png";
import imgTelegram from "media/home/telegram_icon.png";
import imgYT from "media/home/youtube_icon.png";
import HomeStepper from "../../../components/HomeSteper/index";
import { Stepper, Step } from "react-form-stepper";
import KasnetModal from "../../../components/modals/KasnetModal";

import "./styles.css";

import swal from "sweetalert";
import Aos from "aos";
import "aos/dist/aos.css";

// Get FontAwesome Icons
import {
	faHandHoldingUsd,
	faUserLock,
	faTachometerAlt,
	faWeight,
} from "@fortawesome/free-solid-svg-icons";
// Styled components
import {
	Section,
	LaptopImage,
	CaruseleViewStyles,
	Wrapper,
	Space,
} from "styles/Styled";

import {
	PrimaryTextLanding,
	SecondaryTextLanding,
	SecondaryTextLandingSec,
	MainTextLanding,
} from "styles/colorized";

import Styled from "./styles";
import {
	Header1,
	Header1Cards,
	SocialMedia,
	ConfianSectionCarusele,
	Paragraph,
	TitleSection,
} from "styles/common/index.js";
// Get the USD to PEN rate
import { ExchangeProvider } from "ExchangeContext";
// Get the time
import { DateProvider } from "DateContext";

import agentebtcapi from "agentebtcapi.js";

import { Helmet } from "react-helmet";
import { Style } from "victory";

// Print FontAwesome Icons
library.add(faHandHoldingUsd, faUserLock, faTachometerAlt);

const HomeHonduras = ({ history, location }) => {
	window.dataLayer.push({
		event: "pageview",
		page: {
			url: location,
			title: "Home",
		},
	});
	// TagManager.dataLayer(tagManagerArgs);
	const [isOpen, setIsOpen] = useState(true);
	const [openModal, setOpenModal] = useState(false);

	const [count, setCount] = useState(0);

	// Scroll to top on all pages
	const scrollTop = () => {
		window.scrollTo(0, 0);
	};

	const showModal = () => {
		swal({
			text:
				"Estamos fuera de operaciones por el resto del día, para darles un mejor servicio, volveremos muy pronto",
			title: "MANTENIMIENTO BTC",
			buttons: false,
			closeOnClickOutside: false,
		});
	};

	useEffect(() => {
		//scrollTop();
		Aos.init({ duration: 2000 });
		const interval = setInterval(() => {
			//console.log(isVisible);
		}, 1000);

		setInterval(() => {
			setIsOpen(false);
		}, 10000);

		// showModal();
	}, []);

	if (count < 1) {
		setTimeout(() => {
			setCount(count + 1);
		}, 1000);
	}

	// Función para detectar el evento de tecla presionada
	function detectarTecla(event) {
		if (event.keyCode === 27) {
			setOpenModal(false);
		}
	}

	// Agregar el evento al objeto global (puedes utilizar cualquier otro elemento si deseas que el evento esté más específicamente enfocado)
	document.addEventListener("keydown", detectarTecla);

	return (
		<>
			{openModal && (
				<div id="myModal" class="modal">
					<div class="modal-content">
						<div className="modal-content-header-container">
							<div className="modal-content-header-left"></div>
							<div className="modal-content-header-right">
								<span
									class="close"
									onClick={() => {
										setOpenModal(false);
									}}
								>
									&times;
								</span>
							</div>
						</div>

						<div className="modal-content-container">
							<div className="modal-content-col-left">
								<div className="modal-content-col-title">
									Toma el poder de <br />
									<span className="modal-content-col-title-yellow">
										tu propio dinero
									</span>
								</div>

								<div className="modal-content-col-subtitle">
									Escanea el QR con la cámara de tu celular y descarga la APP de
									AgenteBTC.
								</div>

								<a
									className="modal-content-col-qr-image-link"
									href="https://play.google.com/store/apps/details?id=com.agentebtc.appagentebtc&hl=es"
									target="_blank"
								>
									<img
										src="images/home/Qr-APP.png"
										className="modal-content-col-qr-image"
									/>
								</a>
							</div>

							<div className="modal-content-col-right">
								<img
									className="modal-content-col-mobile"
									src="images/home/Mobile-Cryptos.png"
								/>
							</div>
						</div>
					</div>
				</div>
			)}

			<ExchangeProvider>
				<DateProvider>
					<>
						<Styled.HomeContainer>
							<Section style={{ paddingBottom: 15 }}>
								<img
									src={require("../../../media/home/LandBack_1.png")}
									style={{
										position: "absolute",
										zIndex: -1,
									}}
									width={"100%"}
								/>
								<Wrapper>
									<Styled.HeroSection>
										<Styled.HeroText>
											<Styled.TaglineHome>
												<Styled.SecondaryTextLandingSmallerSmaller>
													Compra Bitcoin
												</Styled.SecondaryTextLandingSmallerSmaller>
												&nbsp;
												<Styled.MainTextLandingSmallerSmaller>
													y otras
												</Styled.MainTextLandingSmallerSmaller>
											</Styled.TaglineHome>
											<Styled.TaglineHome>
												<Styled.MainTextLandingSmallerSmaller>
													criptomonedas en Honduras
												</Styled.MainTextLandingSmallerSmaller>
											</Styled.TaglineHome>
											<Styled.SubtaglineHome>
												<Styled.TaglineSpan>
													Compra y vende criptomoneda, inviértelas para recibir
													ganancias diarias y gánale a la inflación.
												</Styled.TaglineSpan>
											</Styled.SubtaglineHome>
											<Styled.ContainerButtons>
												<Styled.StyledButtonBlueExt
													href={`${agentebtcapi.webapp}/auth/register`}
													style={{
														background: `linear-gradient(#FFC500,#F7931E)`,
													}}
												>
													Comenzar
													<img
														style={{
															width: 30,
															paddingLeft: 20,
														}}
														src={require("../../../media/icons/arrowIcon.png")}
													/>
												</Styled.StyledButtonBlueExt>
											</Styled.ContainerButtons>

											<Styled.ButtonAppContainer>
												<a style={{ cursor: "pointer" }}>
													<Styled.ButtonAppImg
														onClick={() => {
															setOpenModal(true);
														}}
														src="https://i.imgur.com/3ahEEX3.png"
													></Styled.ButtonAppImg>
												</a>
											</Styled.ButtonAppContainer>
										</Styled.HeroText>
										<Styled.MainTitleLandingRight>
											<LaptopImage
												src="https://i.imgur.com/C18bLyi.png"
												alt="Cómo comprar criptomnedas"
											/>
										</Styled.MainTitleLandingRight>
									</Styled.HeroSection>
								</Wrapper>
							</Section>


							<Styled.CarusaleContainer>
								<CaruseleViewStyles>
									<CarusaleView />
								</CaruseleViewStyles>
							</Styled.CarusaleContainer>

							
						</Styled.HomeContainer>
						<Styled.WrapperCalculatorSection>
							<Styled.ContainerSectionHeader>
								<Header1>
									Invierte solo <a style={{ color: "#FFC500" }}>en 3 pasos</a>
								</Header1>
								<Paragraph
									style={{
										marginBottom: "130px",
										fontSize: "20px",
										marginTop: "-30px",
										fontWeight: "300",
										color: "#808080",
									}}
								>
									Compra y vende criptomonedas sin ser un experto
								</Paragraph>
								<Styled.WebStepper>
									<Styled.StepperSection
										style={{
											width: "100%",
											justifyContent: "space-around",
										}}
									>
										<img
											style={{
												width: 80,
											}}
											alt="criptomonedas users"
											src={require("../../../media/icons/StepperIcon_1.png")}
										/>
										<img
											style={{
												width: 80,
											}}
											alt="comprar en peru"
											src={require("../../../media/icons/StepperIcon_2.png")}
										/>
										<img
											style={{
												width: 80,
											}}
											alt="bitcoin a dolar, bitcoin a soles, comprar bitcoins"
											src={require("../../../media/icons/StepperIcon_3.png")}
										/>
									</Styled.StepperSection>
								</Styled.WebStepper>
								<Styled.WebStepper>
									<Styled.StepperSection>
										<Stepper
											styleConfig={{
												labelFontSize: 18,
												fontWeight: 400,
												size: 24,
												completedBgColor: "#1A4BEA",
												activeBgColor: "#3C4A5B",
											}}
											connectorStyleConfig={{
												stepSize: "4em",
												width: "100%",
											}}
											style={{
												width: "100%",
												padding: 0,
												paddingBlock: 24,
											}}
										>
											<Step
												key={"Regístrate y verifica tu identidad"}
												label="Regístrate y verifica tu identidad"
												style={{
													backgroundColor: "#1A4BEA",
												}}
												active
											/>
											<Step
												key={"Deposita fondos en tu cuenta"}
												label="Deposita fondos en tu cuenta"
												style={{
													backgroundColor: "lightgrey",
												}}
												active
											/>
											<Step
												key={"¡Compra tu cripto favorita!"}
												label="¡Compra tu cripto favorita!"
												style={{
													backgroundColor: "lightgrey",
												}}
												active
											/>
										</Stepper>
									</Styled.StepperSection>
								</Styled.WebStepper>
								<Styled.StepperSection>
									<Styled.MobileStepper>
										<HomeStepper />
									</Styled.MobileStepper>
								</Styled.StepperSection>

								<Styled.ContainerLogosWithoutTransition
									style={{ alignSelf: "center" }}
								>
									<Styled.StyledButtonBlueExt
										href={`${agentebtcapi.webapp}/auth/register`}
										style={{
											background: `linear-gradient(#FFC500,#F7931E)`,
										}}
									>
										Crear mi cuenta
										<img
											style={{
												width: 30,
												paddingLeft: 20,
											}}
											src={require("../../../media/icons/arrowIcon.png")}
										/>
									</Styled.StyledButtonBlueExt>
								</Styled.ContainerLogosWithoutTransition>
							</Styled.ContainerSectionHeader>
						</Styled.WrapperCalculatorSection>

						{/* Savings working */}
						<div className="home-honduras-savings-container">
							<div className="savings-working">
								<img
									className="savings-image"
									src="https://i.imgur.com/y4d05Ki.png"
								/>
							</div>
						</div>

						{/* Benefits section */}
						<div className="home-hn-benefits-wrapper">
							<Styled.ContainerLogosWithoutTransition
								style={{ alignSelf: "center", marginBottom: 40 }}
							>
								<Styled.StyledButtonBlueExtHn
									href={`${agentebtcapi.webapp}/auth/register`}
									style={{
										background: `linear-gradient(#FFC500,#F7931E)`,
									}}
								>
									Abrir mi cuenta
									<img
										style={{
											width: 40,
											paddingLeft: 40,
										}}
										src={require("../../../media/icons/arrowIcon.png")}
									/>
								</Styled.StyledButtonBlueExtHn>
							</Styled.ContainerLogosWithoutTransition>

							<div className="home-hn-benefits-title">
								Beneficios de abrir una&nbsp;
								<span className="home-hn-benefits-title-span">
									cuenta en AgenteBTC
								</span>
							</div>

							<div className="home-hn-benefits-container">
								<div className="home-hn-benefits-side">
									<div className="home-hn-benefits-item">
										<img
											className="home-hn-benefits-icon"
											src="https://i.imgur.com/n7x1Rfe.png"
										/>
										<div className="home-hn-benefits-item-text">
											Genera rendimientos desde el primer día.
										</div>
									</div>
									<div className="home-hn-benefits-item">
										<img
											className="home-hn-benefits-icon"
											src="https://i.imgur.com/L1qMwvw.png"
										/>
										<div className="home-hn-benefits-item-text">
											Compra fracciones de criptomonedas.
											<br />
											¡Comienza desde 140 lempiras!
										</div>
									</div>
									<div className="home-hn-benefits-item">
										<img
											className="home-hn-benefits-icon"
											src="https://i.imgur.com/welfG72.png"
										/>
										<div className="home-hn-benefits-item-text">
											Nuestras medidas de gestión de riesgos están diseñadas
											para proteger tus activos.
											{/* <br /> */}
										</div>
									</div>
								</div>

								<div className="home-hn-benefits-center">
									<img
										className="home-hn-benefits-img"
										src="https://i.imgur.com/G8Flzin.png"
									/>
								</div>

								<div className="home-hn-benefits-side">
									<div className="home-hn-benefits-item">
										<img
											className="home-hn-benefits-icon"
											src="https://i.imgur.com/aMYgkqU.png"
										/>
										<div className="home-hn-benefits-item-text">
											Tus ganancias las recibes en el mismo activo que
											invertiste.
											{/* <br /> */}
										</div>
									</div>
									<div className="home-hn-benefits-item">
										<img
											className="home-hn-benefits-icon"
											src="https://i.imgur.com/B7Rr6Su.png"
										/>
										<div className="home-hn-benefits-item-text">
											Nuestro compromiso es ofrecer un servicio 24/7 los 365
											días del año.
											{/* <br /> */}
										</div>
									</div>
									<div className="home-hn-benefits-item">
										<img
											className="home-hn-benefits-icon"
											src="https://i.imgur.com/wQ6QzRh.png"
										/>
										<div className="home-hn-benefits-item-text">
											Vende o retira tus fondos cuando quieras.
										</div>
									</div>
								</div>
							</div>

							<div className="home-hn-benefits-download">
								<Styled.ButtonAppContainer style={{ textAlign: "center" }}>
									<a style={{ cursor: "pointer" }}>
										<Styled.ButtonAppImg
											style={{ marginLeft: "10px" }}
											onClick={() => {
												setOpenModal(true);
											}}
											src="https://i.imgur.com/3ahEEX3.png"
										></Styled.ButtonAppImg>
									</a>
								</Styled.ButtonAppContainer>
							</div>
						</div>

						{/* MTC */}

						<div className="home-download-footer-container">
							<div className="home-download-footer-item">
								<div className="home-download-footer-title">+10MIL</div>
								<div className="home-download-footer-body">Clientes</div>
							</div>

							<div className="home-download-footer-item">
								<div className="home-download-footer-title">+20M</div>
								<div className="home-download-footer-body">
									Volumen Transaccionado
								</div>
							</div>

							<div className="home-download-footer-item">
								<div className="home-download-footer-title">+6</div>
								<div className="home-download-footer-body">Criptomonedas</div>
							</div>

							<div className="home-download-footer-item">
								<div className="home-download-footer-title">+5</div>
								<div className="home-download-footer-body">Países</div>
							</div>
						</div>

						{/* Espacios en la landing original
                        <Space />
                        <Space />
                        

                        <Space />
                        <Space /> */}

						{/* They trust in us Section */}
						<Styled.WrapperCalculatorSectionCarusele>
							<Styled.ContainerSectionHeader>
								<Header1>
									Ellos confían en <a style={{ color: "#FFC500" }}>AgenteBTC</a>
								</Header1>
								<ConfianSectionCarusele
									style={{
										padding: 0,
										backgroundColor: "aliceblue",
									}}
								>
									<MediaCarusel />
								</ConfianSectionCarusele>
							</Styled.ContainerSectionHeader>
						</Styled.WrapperCalculatorSectionCarusele>

						{/* Join the community section */}
						<Styled.WrapperCalculatorSectionImage>
							<Styled.WrapperCalculatorSection>
								<Styled.ContainerSectionHeader style={{ textAlign: "left" }}>
									<TitleSection
										style={{
											fontSize: 32,
											marginBlockEnd: 0,
										}}
									>
										¡Únete a la
									</TitleSection>
									<TitleSection
										style={{
											color: "#1B4BE8",
											fontSize: 32,
											marginBlockStart: 0,
											marginBlockEnd: 0,
										}}
									>
										comunidad criptoagente!
									</TitleSection>
									<Paragraph style={{ fontSize: 18, color: "gray" }}>
										AgenteBTC te ofrece herramientas gratuitas <br /> para
										aprender y conectar más con el mundo cripto.
									</Paragraph>
									<Styled.PressSection style={{ width: "100%" }}>
										<Styled.CardsContainer
											style={{
												flexDirection: "column",
												width: 350,
												backgroundColor: "white",
											}}
											data-aos="fade"
											data-aos-once="true"
										>
											<Styled.ImageBanks
												src={imgBlog}
												style={{
													height: 180,
													width: 250,
													backgroundColor: "#fff",
												}}
												alt="criptomonedas que son, criptomonedas blog"
											/>
											<SocialMedia>
												<Paragraph
													style={{
														fontWeight: "bold",
														paddingLeft: 20,
														marginBlockStart: 10,
														marginBlockEnd: 0,
														fontSize: 22,
													}}
												>
													Blog
												</Paragraph>
												<Paragraph
													style={{
														color: "#3E5158",
														paddingLeft: 20,
														marginBlockStart: 5,
														marginBlockEnd: 0,
														paddingBottom: 15,
													}}
												>
													Contenido educativo y de tendencias.
												</Paragraph>
												<div
													style={{
														marginInline: 10,
														height: 1,
														opacity: 0.1,
														backgroundColor: "#3E5158",
													}}
												/>
												<div
													style={{
														textAlign: "right",
														width: "100%",
														padding: 10,
													}}
												>
													<Styled.SectionsButton href="https://blog.agentebtc.com/">
														Más información
													</Styled.SectionsButton>
												</div>
											</SocialMedia>
										</Styled.CardsContainer>

										<Styled.CardsContainer
											style={{
												flexDirection: "column",
												width: 350,
												backgroundColor: "white",
											}}
											data-aos="fade"
											data-aos-once="true"
										>
											<div>
												<Styled.ImageBanks
													src={imgYT}
													style={{
														height: 180,
														width: 250,
													}}
													alt="criptomonedas que son, criptomonedas youtube"
												/>
											</div>
											<SocialMedia>
												<Paragraph
													style={{
														fontWeight: "bold",
														paddingLeft: 20,
														marginBlockStart: 10,
														marginBlockEnd: 0,
														fontSize: 22,
													}}
												>
													Youtube
												</Paragraph>
												<Paragraph
													style={{
														color: "#3E5158",
														paddingLeft: 20,
														marginBlockStart: 5,
														marginBlockEnd: 0,
														paddingBottom: 15,
													}}
												>
													Tutoriales / Entrevistas / Webinars.
												</Paragraph>
												<div
													style={{
														marginInline: 10,
														height: 1,
														opacity: 0.1,
														backgroundColor: "#3E5158",
													}}
												/>
												<div
													style={{
														textAlign: "right",
														width: "100%",
														padding: 10,
													}}
												>
													<Styled.SectionsButton href="https://www.youtube.com/c/AgenteBTC">
														Más información
													</Styled.SectionsButton>
												</div>
											</SocialMedia>
										</Styled.CardsContainer>
										<Styled.CardsContainer
											style={{
												flexDirection: "column",
												width: 350,
												backgroundColor: "white",
											}}
											data-aos="fade"
											data-aos-once="true"
										>
											<Styled.ImageBanks
												src={imgTelegram}
												style={{
													height: 180,
													width: 250,
												}}
												alt="criptomonedas que son, criptomonedas telegram"
											/>
											<SocialMedia>
												<Paragraph
													style={{
														fontWeight: "bold",
														fontSize: 22,
														paddingLeft: 20,
														marginBlockStart: 10,
														marginBlockEnd: 0,
													}}
												>
													Telegram
												</Paragraph>
												<Paragraph
													style={{
														color: "#3E5158",
														paddingLeft: 20,
														marginBlockStart: 5,
														marginBlockEnd: 0,
														paddingBottom: 15,
													}}
												>
													Comunidad CRIPTOAGENTES.
												</Paragraph>
												<div
													style={{
														marginInline: 10,
														height: 1,
														opacity: 0.1,
														backgroundColor: "#3E5158",
													}}
												/>
												<div
													style={{
														textAlign: "right",
														width: "100%",
														padding: 10,
													}}
												>
													<Styled.SectionsButton href="https://t.me/agenteBTC_PE">
														Más información
													</Styled.SectionsButton>
												</div>
											</SocialMedia>
										</Styled.CardsContainer>
									</Styled.PressSection>
								</Styled.ContainerSectionHeader>
							</Styled.WrapperCalculatorSection>
						</Styled.WrapperCalculatorSectionImage>

						{/* New mobile ad*/}
						<div className="home-hn-mobile-ad-end">
							<div className="hn-mobile-ad-text-container">
								<div>
									Compra tu primera cripto fácilmente
									<br />
									<span className="hn-mobile-ad-span">empezando desde $5</span>
								</div>

								<Styled.ButtonAppContainer>
									<a style={{ cursor: "pointer" }}>
										<Styled.ButtonAppImg
											onClick={() => {
												setOpenModal(true);
											}}
											src="https://i.imgur.com/3ahEEX3.png"
										></Styled.ButtonAppImg>
									</a>
								</Styled.ButtonAppContainer>
							</div>

							<div className="hn-mobile-ad-img-container">
								<img
									className="hn-mobile-ad-img"
									src="https://i.imgur.com/gDnB2oH.png"
								/>
							</div>

							<div className="hn-mobile-ad-download-mobile">
								<Styled.ButtonAppContainer style={{textAlign:"center"}}>
									<a style={{ cursor: "pointer", margin: "0 auto"}}>
										<Styled.ButtonAppImg
											onClick={() => {
												setOpenModal(true);
											}}
											style={{width: "200px"}}
											src="https://i.imgur.com/3ahEEX3.png"
										></Styled.ButtonAppImg>
									</a>
								</Styled.ButtonAppContainer>
							</div>
						</div>

						<KasnetModal />
					</>
				</DateProvider>
			</ExchangeProvider>

			<Helmet>
				<meta charSet="utf-8" />
				<title>
					Compra y vende Bitcoin en Perú con Soles y Dólares | Agente BTC
				</title>
				<meta
					name="description"
					content="Compra y venta de Bitcoin en Perú. Invierte fácil y seguro en nuestra plataforma mediante transferencia bancaria."
				/>
				<meta property="og:type" content="website" />
				<meta property="og:url" content="https://agentebtc.com/" />
				<meta
					property="og:title"
					content="Compra y venta de Bitcoin en Perú. Invierte fácil y seguro en nuestra plataforma mediante transferencia bancaria."
				/>
				<meta
					property="og:description"
					content="La experiencia más simple y segura de compra y venta de criptomonedas en Perú. Deposita dinero sin comisiones, operaciones seguras las 24h, asesoría personalizada."
				/>
				<meta
					property="og:image"
					content="https://www.agentebtc.com/static/media/WebappLanding.2fb3f1b4.png"
				/>
				<meta property="twitter:card" content="summary_large_image" />
				<meta property="twitter:url" content="https://agentebtc.com/" />
				<meta
					property="twitter:title"
					content="Compra y venta de Bitcoin en Perú. Invierte fácil y seguro en nuestra plataforma mediante transferencia bancaria."
				/>
				<meta
					property="twitter:description"
					content="La experiencia más simple y segura de compra y venta de criptomonedas en Perú. Deposita dinero sin comisiones, operaciones seguras las 24h, asesoría personalizada."
				/>
				<meta
					property="twitter:image"
					content="https://www.agentebtc.com/static/media/WebappLanding.2fb3f1b4.png"
				/>
			</Helmet>
		</>
	);
};

export default withRouter(HomeHonduras);
